import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class TackleFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.Tackle;
    }

    getRawFragmentForState(play, serializationContext, state, fragment) {
        const values = [
            fragment
                .getPlayers()
                .map((p) => this.resolveUniform(serializationContext, p))
                .join()
        ];

        return `${fragment.code}:${values.join()}`;
    }

    getRawFragment(play, serializationContext, tackle) {
        return this.getRawFragmentForState(
            play,
            serializationContext,
            FootballState.Tackle,
            tackle
        );
    }
}
